<script setup>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import ChipDeposit from "./ChipDeposit.vue";
import ChipWithdraw from "./ChipWithdraw.vue";
import BangkingHistory from "./BangkingHistory.vue";
import NoticeList from "./NoticeList.vue";
import inquiryHistory from "./InquiryHistory.vue";
import inquiry from "./InquiryRequest.vue";
import MyInfo from "./MyInfo.vue";
import PointToChip from "./PointToChip.vue";
import BettingHistory from "./BettingHistory.vue";
//**del
// import FAQ from "./FAQ.vue";

const store = useStore();
const { t } = useI18n();
const selectedTab = computed(() => store.state.homePopupTab);
const tabTitle = ref("");

watch(selectedTab, (newValue) => {
  if (!newValue) {
    return;
  }
  setTimeout(() => {
    const s = `.menu-item.${newValue}`;
    const e = document.querySelector(s);
    if (e) {
      tabTitle.value = e.textContent;
    }
  }, 1);
});

function changeTab(e, tab) {
  tabTitle.value = e.target.textContent;
  store.dispatch("showHomePopup", { open: true, tab });
}

function close() {
  store.dispatch("showHomePopup", { open: false });
}
</script>

<template>
  <div class="subpage-wrapper d-block" v-if="store.state.homePopup">
    <div class="subpage-container">
      <button class="close-subpage" @click="close">x</button>
      <div class="subpage-inner">
        <div class="modal-contents">
          <div class="side-menu">
            <div class="sidemenu-header">{{ t('homePopup.selectList') }}</div>
            <div class="menu">
              <a
                href="javascript:void(0)"
                class="menu-item recharege"
                @click="(e) => changeTab(e, 'recharege')"
              >
                <i class="fa-solid fa-piggy-bank"></i>
                {{ t('homePopup.deposit') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item exchange"
                @click="(e) => changeTab(e, 'exchange')"
              >
                <i class="fa-solid fa-vault"></i>
                {{ t('homePopup.withdrawal') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item bangkingHistory"
                @click="(e) => changeTab(e, 'bankingHistory')"
              >
                <i class="fa-solid fa-list"></i>
                {{ t('homePopup.bankingHistory') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item betHistory"
                @click="(e) => changeTab(e, 'betHistory')"
              >
                <i class="fa-solid fa-clock-rotate-left"></i>
                {{ t('homePopup.betHistory') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item pointToChip"
                @click="(e) => changeTab(e, 'pointToChip')"
              >
                <i class="fa-solid fa-money-bill-transfer"></i>
                {{ t('homePopup.pointToChip') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item notice"
                @click="(e) => changeTab(e, 'notice')"
              >
                <i class="fa-solid fa-bell"></i>
                {{ t('homePopup.notice') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item inquiry"
                @click="(e) => changeTab(e, 'inquiry')"
              >
                <i class="fa-solid fa-comment-dots"></i>
                {{ t('homePopup.inquiry') }}
              </a>
              <a
                href="javascript:void(0)"
                class="menu-item myInfo"
                @click="(e) => changeTab(e, 'myInfo')"
              >
                <i class="fa-solid fa-circle-info"></i>
                {{ t('homePopup.myInfo') }}
              </a>
              <!-- **del -->
              <!-- <a
                href="javascript:void(0)"
                class="menu-item faq"
                @click="(e) => changeTab(e, 'faq')"
              >
                <i class="fa-solid fa-question-circle"></i>
                {{ t('homePopup.faq') }}
              </a> -->
            </div>
          </div>
          <div class="subpage-content">
            <div class="subpagecontent-header">
              {{ tabTitle }}
            </div>
            <div class="content">
              <div
                id="deposit"
                class="table-responsive active recharege"
                v-if="selectedTab === 'recharege'"
              >
                <ChipDeposit />
              </div>
              <div
                id="withdraw"
                class="table-responsive active exchange"
                v-else-if="selectedTab === 'exchange'"
              >
                <ChipWithdraw />
              </div>
              <div
                id="bankingHistory"
                class="table-responsive active bankingHistory"
                v-else-if="selectedTab === 'bankingHistory'"
              >
                <BangkingHistory />
              </div>
              <div
                id="pointToChip"
                class="table-responsive active pointToChip"
                v-else-if="selectedTab === 'pointToChip'"
              >
                <PointToChip />
              </div>
              <div
                id="notice"
                class="table-responsive active notice"
                v-else-if="selectedTab === 'notice'"
              >
                <NoticeList />
              </div>
              <div
                id="inquiry"
                class="table-responsive active inquiry"
                v-else-if="selectedTab === 'inquiry'"
              >
                <inquiryHistory />
                <inquiry />
              </div>
              <div
                id="myInfo"
                class="table-responsive active myInfo"
                v-else-if="selectedTab === 'myInfo'"
              >
                <MyInfo />
              </div>
              <div
                id="betHistory"
                class="table-responsive active betHistory"
                v-else-if="selectedTab === 'betHistory'"
              >
                <BettingHistory />
              </div>
              <!-- **del -->
              <!-- <div
                id="faq"
                class="table-responsive active faq"
                v-else-if="selectedTab === 'faq'"
              >
                <FAQ />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "bootstrap/dist/css/bootstrap.css";
@import "bootstrap-vue/dist/bootstrap-vue.css";
@import "../../common.css";
@import "./HomePopup.css";

.btn {
  padding: 4px 8px !important;
  min-width: auto !important;
  height: auto !important;
  border-radius: 4px !important;
}

.w-12 {
  width: 3rem !important;
}
</style>
